/*
 *   File : edit-sip.js
 *   Author : https://evoqins.com
 *   Description : Edit sip modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useState } from 'react';
import { addDays, addMonths, format } from 'date-fns';

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton } from '../Buttons';
import { CustomAmountInput, CustomDatePicker } from '../FormElements';
import { _formatSIPDate } from '../../Helper';
import { APIService } from '../../Service';
import { toast } from 'react-toastify';

function EditSIPModal(props) {

    const [sipAmount, setSipAmount] = useState(props.selectedSIP.amount);
    const [sipAmountError, setSipAmountError] = useState("");
    const [loader, setLoader] = useState(false);
    const [selectedDate, setSelectedDate] = useState(props.selectedSIP.next_sip_date ? new Date(props.selectedSIP.next_sip_date) : null);
    const [sipDateError, setSipDateError] = useState("");
    const [showDatePicker, setShowDatePicker] = useState(false);

    // handle open and close sip date picker
    const _handleToggleSIPDatePicker = () => {
        setShowDatePicker((prev) => !prev);
        // document.querySelector("#sip-date").scrollIntoView({
        //     top: 0,
        //     behavior: "smooth"
        // })
    };

    // handle SIP date select
    const _handelSIPDateSelect = (date) => {
        setShowDatePicker(false);
        setSelectedDate(date);
        setSipDateError("");
    };

    // handle close the date pick dropdown
    const _handleCloseDatePicker = () => {
        setShowDatePicker(false);
    };

    // handle clear the selected date
    const _handleClearDate = () => {
        setSelectedDate(null);
    };

    // handle SIP amount change
    const _handleSIPAmountChange = (value) => {
        setSipAmount(value);
        setSipAmountError("");
    };

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("sip-edit-modal-close");
        button.click();
        props.handleClose();
    };

    // handle success
    const _handleConfirmEdit = () => {

        let validation = true;
        if (selectedDate == null) {
            setSipDateError("Please select date");
            validation = false;
        }
        if (sipAmount === "") {
            setSipAmountError("Please enter amount");
            validation = false;
        }
        if (validation) {
            // API call
            setLoader(true);
            _editSIPDetail();

        }
    };


    /////////////////////////////////
    //  API  -  Get active list data //
    const _editSIPDetail = async () => {
        let url = "portfolio/edit-sip";
        let data = {
            "amount": Number(sipAmount),
            "next_sip_date": format(selectedDate, "yyyy-MM-dd"),
            "sip_start_date": props.selectedSIP.sip_start_date,
            "tenant_id": Number(props.selectedSIP.creator_id),
            "sip_id": Number(props.selectedSIP.sip_id),
            "duration": Number(props.selectedSIP.duration),
            "email_id": props.userData.email,
            "remaining_sip_duration": Number(props.selectedSIP.remaining_sip_duration),
            "execution_partner": props.selectedSIP.execution_partner,
            "portfolio_id": props.selectedSIP.portfolio_id,
            "sip_type": props.selectedSIP.sip_type,
            "status": props.selectedSIP.status,
            "strategy_id": props.selectedSIP.strategy_id,
            "strategy_name": props.selectedSIP.strategy_name,
            "user_id": props.selectedSIP.user_id
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {

            var button = document.getElementById("sip-edit-modal-close");
            button.click();
            props.handleSuccess();

            toast.dismiss();
            toast.success(`${props.selectedSIP.strategy_name} SIP date edited successfully`);
        } else {
            toast.dismiss();
            toast.error(response.message);
        }

        setLoader(false);

    };

    return (
        <div className="modal fade"
            id="sip-edit-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SIP edit modal label"
            aria-hidden="true">

            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16">
                <span id='sip-edit-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 border-0">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center p-3">
                        <h3 className='mb-0 e-text-chinese-black e-primary-font-clash-display e-font-weight-500 e-font-16 line-height-24px'>
                            Edit SIP
                        </h3>
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className={`${showDatePicker ? "min-vh-100" : ""} modal-body pt-0 px-3 pb-3 overflow-scroll`}>
                        <div className="d-flex gap-2 mb-3">
                            <img src={props.selectedSIP.strategy_logo}
                                draggable={false}
                                width={48}
                                alt='product' />
                            <div>
                                <p className='mb-2 e-text-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px' >
                                    {props.selectedSIP.strategy_name}
                                </p>
                                <p className='mb-0 e-text-philippine-gray e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                    by {props.selectedSIP.creator_info.creator_name}
                                </p>
                            </div>
                        </div>

                        <div className="col-sm-10">

                            {/* SIP date picker  */}
                            {/* <div className="position-relative mb-3" id="sip-date">
                                <div className={`${showDatePicker ? "e-border-0-5-ocean-blue" : "e-border-0-5px-chinese-silver"}  px-2 padding-10px-tb border-radius-8 d-flex justify-content-between cursor-pointer`}
                                    onClick={_handleToggleSIPDatePicker}>
                                    <p className={`${selectedDate ? "e-text-chinese-black e-font-weight-600 e-font-14" : "e-text-slate-gray e-font-weight-400 e-font-12"} mb-0 e-alt-font-lato  line-height-18px`}>
                                        {selectedDate ? _formatSIPDate(selectedDate || 1) : "Choose a date"}
                                    </p>
                                    <Icon icon={"calendar"}
                                        className="d-flex"
                                        size="16px" />
                                    <p className={`position-absolute start-0 top-100 mb-0 e-text-vermilion e-alt-font-lato e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                                        {sipDateError}
                                    </p>
                                </div>
                                {
                                    showDatePicker &&
                                    <SIPDateModal selectedDate={selectedDate}
                                        handleSelectDate={_handelSIPDateSelect}
                                        handleCloseModal={() => setShowDatePicker(false)} />
                                }
                            </div> */}

                            {/* SIP Date */}
                            <CustomDatePicker label="Monthly SIP Date"
                                placeholder="Choose a date"
                                require
                                overlay
                                padding="padding-10px-tb  padding-10px-lr"
                                selected={selectedDate}
                                toggle={showDatePicker}
                                error={sipDateError}
                                startDate={new Date()}
                                minDate={new Date()}
                                maxDate={addMonths(new Date(), 1)}
                                wrapperClass="mt-4"
                                handleToggle={_handleToggleSIPDatePicker}
                                handleClose={_handleCloseDatePicker}
                                handleClear={_handleClearDate}
                                handleSelect={_handelSIPDateSelect} />


                            <CustomAmountInput label="Monthly SIP amount"
                                placeholder="Enter amount"
                                require
                                prefix="₹"
                                padding="padding-10px-tb ps-4"
                                value={sipAmount}
                                error={sipAmountError}
                                className="w-100"
                                handleChange={_handleSIPAmountChange} />

                            <PrimaryButton name="Confirm"
                                status={loader}
                                disabled={loader}
                                className="w-100 margin-30px-top h-48"
                                onPress={_handleConfirmEdit} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(EditSIPModal);